import React from 'react'
import styled from 'styled-components'
import { Column } from 'components/common/layout'
import { BaseText, MediumText, SemiBoldText } from 'components/common/text'
import { LinearText } from 'components/scouts/landing/text'
import { PositionType, ScoutPreAnalysis, TechStack } from 'types/common'
import { displayExperienceDesc } from 'utils/displays'

export const PreAnalysis: React.FC<{
  user: {
    experience: number
    interestedPositionTypes: PositionType[]
    interestedTechStacks: TechStack[]
  }
  preAnalysis: ScoutPreAnalysis
}> = ({ user, preAnalysis }) => {
  return (
    <>
      <Column style={{ gap: 8 }}>
        <BaseText style={{ fontSize: 44 }}>🎉</BaseText>
        <TextWrapper>
          <MainText>{'내가 받게 될\n스카우트 제안'}</MainText>
          <SubText>
            <SemiboldSubText>
              {user.interestedPositionTypes
                .slice(0, 2)
                .map((p) => p.name)
                .join(' ‧ ')}
              {user.interestedPositionTypes.length > 2 ? '... ' : ' '}
            </SemiboldSubText>
            <GraySubText>포지션에</GraySubText>
            <br />
            {user.interestedTechStacks.length > 0 && (
              <>
                <SemiboldSubText>
                  {user.interestedTechStacks
                    .slice(0, 2)
                    .map((p) => p.name)
                    .join(' ‧ ')}
                  {user.interestedTechStacks.length > 2 ? '... ' : ' '}
                </SemiboldSubText>
                <GraySubText>스킬을 보유한</GraySubText>
                <br />
              </>
            )}
            <SemiboldSubText>
              {user.experience
                ? displayExperienceDesc(user.experience) + ' 경력'
                : '신입/인턴'}
            </SemiboldSubText>
            <GraySubText> 인재는, 지금</GraySubText>
          </SubText>
        </TextWrapper>
      </Column>
      <CountCard>
        <CountTextWrapper>
          <CountText>{preAnalysis.similarTalentProposedCount}개</CountText>
          <CountDescText>스카우트 제안을 받고 있어요</CountDescText>
        </CountTextWrapper>
        <CountTextWrapper>
          <CountText>{preAnalysis.startupsSeekingMeCount}개</CountText>
          <CountDescText>스타트업이 찾고 있어요</CountDescText>
        </CountTextWrapper>
      </CountCard>
    </>
  )
}

const MainText = styled(SemiBoldText)`
  line-height: 1.4;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.h4};
    white-space: nowrap;
  }
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: 44px;
    font-weight: ${(p) => p.theme.fontWeight.bold};
  }
`

const SubText = styled(BaseText)`
  line-height: 1.8;
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.h5};
  }
`

const TextWrapper = styled(Column)`
  gap: 12px;
  @media ${(p) => p.theme.deviceSize.desktop} {
    gap: 24px;
  }
`

const SemiboldSubText = styled.span`
  font-weight: ${(p) => p.theme.fontWeight.semiBold};
`

const GraySubText = styled.span`
  color: ${(p) => p.theme.color.gray1};
`

const CountCard = styled(Column)`
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 20px;
    gap: 24px;
    border-radius: 12px;
    border: 1px solid ${(p) => p.theme.color.line};
  }
  @media ${(p) => p.theme.deviceSize.desktop} {
    flex-direction: row;
    justify-content: flex-start;
    gap: 40px;
    margin: 40px 0;
  }
`

const CountTextWrapper = styled(Column)`
  gap: 4px;
  @media ${(p) => p.theme.deviceSize.desktop} {
    gap: 8px;
  }
`

const CountDescText = styled(MediumText)`
  color: ${(p) => p.theme.color.black2};
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.h5};
  }
`

const CountText = styled(LinearText)`
  font-size: ${(p) => p.theme.fontSize.h2};
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: 44px;
  }
`
